<script>
import TimerApp from './Timer';

export default {
  name: 'Construction-App',
  components: {
    'timer-app': TimerApp,
  },
  data() {
    return {
      static_url: process.env.OOIURL,
      startTime: process.env.ConstructionStart,
      endTime: process.env.ConstructionEnd,
      wordString: {
        day: 'Day',
        hours: 'Hours',
        minutes: 'Minutes',
        seconds: 'Seconds',
        expired: '',
        running: '',
        upcoming: '',
        status: {
          expired: 'Expired',
          running: 'Until we are finished improving the portal.',
          upcoming: 'Coming soon...',
        },
      },
    };
  },
  methods: {
    calculateHeight(width) {
      return (250 / 550) * width;
    },
  },
  computed: {
    playerWidth() {
      return 1000;
    },
    playerHeight() {
      return this.calculateHeight(this.playerWidth);
    },
  },
  mounted() {
    // eslint-disable-next-line no-undef
    jwplayer('jw-container').setup({
      autostart: true,
      mute: true,
      id: 'playerID',
      width: `${this.playerWidth}px`,
      height: `${this.playerHeight}px`,
      aspectratio: '16:9',
      repeat: true,
      sources: [
        // {
        //   file:
        //     'https://stream.ocean.washington.edu:443/rsnPhone/mp4:r1719highlights_phone.m4v/playlist.m3u8',
        // },
        // Backup video file
        {
          file:
          'https://stream.ocean.washington.edu/rsn/mp4:j1264_castle_vent_720p.m4v/playlist.m3u8',
        },
      ],
      rtmp: { bufferlength: 3 },
    });
  },
};
</script>
<template>
<div class="construction-container">
  <b-container id="timer" class="timer const-container p-0">
    <b-row class="m-0">
      <b-col class="p-2">
        <div :style="`margin: auto; width: ${playerWidth}px`">
            <div id="jw-container"></div>
        </div>
      </b-col>
    </b-row>
    <hr class="my-4">
    <b-row class="m-0">
      <b-col class="p-4" >
        <h3 style="color: #EDEDED;">
          Hi! Welcome to the interactive oceans data portal.
          <br />We are currently undergoing a significant update.
          We apologize for any inconvenience.
        </h3>
        <br />
        <timer-app
          :starttime="startTime"
          :endtime="endTime"
          :wordString="wordString"
        ></timer-app>
        <br />
        <p
          style="color: #F2F2F2;"
        >In the meantime, checkout our website for more information about this project.</p>
        <b-btn
          size="sm"
          :href="static_url"
          variant="primary"
          style="font-size: 0.75em;">
            Click Here
          </b-btn>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<style>
.construction-container {
  height: 100% !important;
  width: 100% !important;
  background-color: rgb(26, 31, 38);
  overflow-y: scroll;
}
</style>
